<template>
  <div class="container">
    <PlaceHolderTable />
  </div>
</template>

<script>
  import PlaceHolderTable from './PlaceHolderTable'

  export default {
    components: {
      PlaceHolderTable
    },
  }

</script>
